module.exports = __webpack_public_path__ + "img/search-stores.e38643b0.svg";